/**

O arquivo main.js eh o javascript principal do site. Nele fazemos o import
de todas as bibliotecas principais e importamos as rotas. Aqui que o
Vue é chamado pra fazer a renderização do site.

*/

import Vue from 'vue'
import Vuex from 'vuex'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMaterial from 'vue-material'
import VueAnalytics from 'vue-analytics'
import SocialSharing from 'vue-social-sharing'
import AsyncComputed from 'vue-async-computed'
import Meta from 'vue-meta'
import './components/default.css'
import './components/vue-material.min.css'
import app from './App.vue'
import createRouter from './router.js'
import { store } from './store'
import LogRocket from 'logrocket';
LogRocket.init(process.env.VUE_APP_LR);

//  Bibliotecas principais sendo chamadas para o uso no site.
Vue.use(Vuex);
Vue.use(VueMaterial);
Vue.use(AsyncComputed); // minimap geolocation functions
Vue.use(SocialSharing);
Vue.use(Meta);

// Chave do Google Maps
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCFavGYhDKPwejBo1ATRV3LATx0FHlmkfk',
    // libraries: "places"
  }
})

//  Aqui linkamos as rotas declaradas no ./router.js via VueRouter
const router = createRouter()

const isProduction = process.env.NODE_ENV === 'production';

if (process.env.VUE_APP_GATID) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GATID,
    router,
    autotracking: {
      exception: true,
      screenview: true,
      page: true
    },
    debug: {
      enabled: !isProduction,
      sendHitTask: isProduction,
    }
  })
}

Vue.config.productionTip = !isProduction;

//  Aqui definimos as propriedades do site. Renderizamos o App e aplicamos o router
new Vue({
  render: h => h(app),
  router,
  store
}).$mount('#app')
